import React, { Component } from 'react'
import { Autocomplete, FormControl, TextField } from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

const REGEX_OPTIONS = [
    { value: '', labelKey: 'Select an option' },
    { value: '#^[0-9]*$#i', labelKey: 'Numbers only' },
    { value: '#^[0-9]{4}[A-Z]{2}$#', labelKey: 'Zipcode netherlands' },
    { value: '/^[0-9]{4}$/', labelKey: 'Municipal code' },
    {
        value: '/^[a-zA-Z]+(([\',. -][a-zA-Z ])?[a-zA-Z]*)*$/',
        labelKey: 'Denomination',
    },
]

class DefFieldTextSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            item: this.props.item,
            size:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.size
                    ? this.props.item.settings.size
                    : 100,
            regex:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.regex
                    ? this.props.item.settings.regex
                    : null,
        }

        this.onChange = this.onChange.bind(this)
        this.onRegexOptionChange = this.onRegexOptionChange.bind(this)
    }

    onChange(event) {
        let item = this.state.item
        if (!item.settings) {
            item.settings = { [event.target.name]: event.target.value }
        }

        item.settings[event.target.name] = event.target.value
        this.setState({ item: item })

        this.props.onChange(event.target.name, event.target.value)
    }

    onRegexOptionChange(_event, option) {
        const next = option?.value ?? ''
        let item = this.state.item
        if (!item.settings) {
            item.settings = {}
        }
        item.settings.regex = next
        this.setState({ item, regex: next === '' ? null : next })
        this.props.onChange('regex', next)
    }

    render() {
        const { kedo } = this.props
        const { item } = this.state
        const regexValue = item.settings?.regex || ''
        const options = REGEX_OPTIONS.map((option) => ({
            value: option.value,
            label: kedo.t(option.labelKey),
        }))
        const selected =
            options.find((option) => option.value === regexValue) ||
            (regexValue ? null : options[0])

        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Regular expression')}
                    </FormInputLabel>
                    <Autocomplete
                        size="small"
                        autoComplete
                        autoHighlight
                        options={options}
                        getOptionLabel={(option) => option?.label || ''}
                        isOptionEqualToValue={(a, b) => a?.value === b?.value}
                        value={selected}
                        onChange={this.onRegexOptionChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                placeholder={kedo.t('Select an option')}
                            />
                        )}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Custom regular expression')}
                    </FormInputLabel>
                    <TextField
                        value={item.settings.regex || ''}
                        name="regex"
                        onChange={this.onChange}
                        fullWidth
                        size="small"
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Size')}</FormInputLabel>
                    <TextField
                        type="number"
                        value={item.settings.size || 100}
                        name="size"
                        onChange={this.onChange}
                        fullWidth
                        size="small"
                    />
                </FormControl>
            </div>
        )
    }
}

export default DefFieldTextSettings
